const keyCodes = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40,
  delete: 46,
  comma: 188,
  shift: 16,
  meta: 91,
};

export default keyCodes;
